import { Component, OnInit, HostListener,ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { routeAnimations } from '../../animations/routerAnimations';
import { ActivatedRoute, Router } from '@angular/router';
import { StoryblokService } from '../../services/storyblok.service'
import { NavService } from '../../services/nav.service'
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-project-page',
  templateUrl: './project-page.component.html',
  styleUrls: ['./project-page.component.scss'],
  animations: [
    routeAnimations
  ]
})
export class ProjectPageComponent implements OnInit {
  public project
  public loaded = false
  public playVideo = false

  constructor(
    private storyBlokService: StoryblokService,
    private route: ActivatedRoute,
    private navService: NavService,
    private router: Router,
    private sanitize: DomSanitizer,
  ) { }

  @ViewChild('videoPlayer', {static: false}) videoplayer: ElementRef;

  ngOnInit() {
    this.route.paramMap.subscribe(route => {
      let slug = route.get('slug')
      this.storyBlokService.getStory(`projects/${slug}`).then(data => {
        this.project = data.story

        this.loaded = true
      })
    })
  }

  goToProjects() {
    this.router.navigate(['/'], {queryParams: {p: 'projects'}})
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.videoplayer.nativeElement.play();
    } else {
      this.videoplayer.nativeElement.pause();
    }
  }

}
